import http from "./httpService";
import auth from "./authService";

const headers = {
  headers: {
    "Content-Type": "multipart/form-data"
  }
};


function supplierStoreUrl(id) {
  if (id) return `/v1/paid-cheques/${id}`;
  else return `/v1/paid-cheques`;
}

export function getAll() {
  return http.get(supplierStoreUrl());
}

export function deleteSingle(supplierId) {
  return http.delete(supplierStoreUrl(supplierId));
}

export function saveSingle(supplier) {
  return http.post(supplierStoreUrl(), supplier, headers);
}

export function updateSingle(supplier,pcid) {
  return http.post(supplierStoreUrl(pcid), supplier, headers);
}

export function updateSingleStatus(supplier) {
  return http.get(`/v1/paid-cheques/${supplier.id}/status`);
}

export function getSingle(supplierId) {
  return http.get(supplierStoreUrl(supplierId));
}
